import { createSelector } from 'reselect';
import { getPublishedRewardsForProject } from '../project/projects-reducer';

export const getRewardForItem = createSelector(
    [getPublishedRewardsForProject, (state, projectId, item) => item.rewardId],
    (rewards, rewardId) => rewards?.find((r) => r.id === rewardId)
);
